import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';

interface IExportModel {
    variables?: {
        id: number;
        upgradeType?: string;
    };
}

export const EXPORT_MODEL = gql`
    mutation UseExportModel($id: ID!, $upgradeType:SemanticVersion) {
        exportModel(id:$id, upgrade_type:$upgradeType ){
            code
            body
            version
        }
    }
`;
const useExportModel = ({ variables }: IExportModel) => {
    return useMutation(EXPORT_MODEL, {
        variables,
        awaitRefetchQueries: true,
    });
};
export { useExportModel };
